import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const Create = (accommodation) => {
    return vdkHappinessPortalApi.post(`accommodation/add-or-edit-accommodation`, accommodation);
};
const GetByPersonId = (personId) => {
    return vdkHappinessPortalApi.get(`accommodation/${personId}/get-accommodation-by-person-id`);
};
const AccommodationApi = {
    Create,
    GetByPersonId
};
export default AccommodationApi;
